import { AuthProvider, OAuthProvider as FirebaseOAuthProvider, getAuth, GoogleAuthProvider, signInWithPopup, UserCredential } from 'firebase/auth';
import { createContext, PropsWithChildren, useCallback, useContext } from 'react';

interface OAuthContextType {
    login: (type: OAuthProvider) => Promise<UserCredential>;
}

type OAuthProvider = 'google' | 'microsoft';

const OAuthContext = createContext<OAuthContextType | undefined>(undefined);

export const OAuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const login = useCallback(async (type: OAuthProvider) => {
        let provider: AuthProvider;
        switch (type) {
            case 'google':
                provider = new GoogleAuthProvider();
                break;
            case 'microsoft':
                provider = new FirebaseOAuthProvider('microsoft.com');

                break;
            default:
                throw new Error(`Unsupported provider: ${type}`);
        }

        const auth = getAuth();
        auth.useDeviceLanguage();

        return signInWithPopup(auth, provider);
    }, []);

    return (
        <OAuthContext.Provider
            value={{
                login,
            }}
        >
            {children}
        </OAuthContext.Provider>
    );
};

export const useOAuth = (): OAuthContextType => {
    const context = useContext(OAuthContext);
    if (!context) {
        throw new Error('useOAuth must be used within an OAuthProvider');
    }

    return context;
};
